/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled, { css } from 'styled-components';
import { FiraSansExtraLight, FontWeight } from 'components/Text/Text';
import Colors from 'constants/Colors';

export const DragZoneContainer = styled.div`
  width: 100%;
  padding: 10px;
  border: 3px dashed ${({ isDragging }) => !isDragging ? Colors.GRAY[0] : Colors.PURPLE};
  border-radius: 8px;
  min-height: ${({ height }) => height ? 'unset' : '150px'} ;
  text-align: center;
  color: ${({ isDragging }) => !isDragging ? Colors.GRAY[0] : Colors.PURPLE};
  display: flex;
  flex-flow: column;
  flex-direction: column;
  ${({ fullHeight }) => fullHeight? 'height: 92%' : ""}
  ${({ height, fullHeight }) => height && !fullHeight ? `height: ${height}%` : ''};
`;

export const TableContainer = styled.div`
  width: 100%;
  padding: 10px;
  min-height: 150px;
`;

export const DropZoneArea = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  ${FiraSansExtraLight}
  flex: 1;
`;


export const ButtonContent = styled.div`
  display:flex;
  flex-direction:auto;
  justify-content:space-evenly;
`;

export const AddButton = styled.button`
  display: flex;
  width:50px;
  height:50px;
  border: 0px;
  background-color:transparent;
  cursor: pointer;
  align-self: center;
`;

export const TagInput = styled.input`
  flex: 1;
  display:none;
  border: none;
  width:100%;
  
  &:focus {
      outline: transparent;
  }
`;